import type { ReactNode } from 'react';
import { Info } from 'lucide-react';
import { Label } from '@r/components/ui/label.tsx';
import { Tooltip, TooltipContent, TooltipTrigger } from '@r/components/ui/tooltip.tsx';
import { useFormField } from '@r/components/ui/form.tsx';

export const ContentBlockSlideFieldLabel = ({
  label,
  hint,
  showHintInTooltip,
  required
}: {
  label: ReactNode;
  hint?: string;
  showHintInTooltip: boolean;
  required?: boolean;
}) => {
  const { formItemId } = useFormField();

  return (
    <div className="inline-flex min-h-[14px] items-center gap-1">
      <Label
        htmlFor={formItemId}
        className="mb-0 inline pl-0 text-[11px] font-bold uppercase leading-[14px] tracking-wider text-muted-foreground"
      >
        {label}
      </Label>
      {required ? (
        <span className="text-[11px] leading-[14px] text-destructive" aria-hidden>
          *
        </span>
      ) : null}
      {showHintInTooltip && hint ? (
        <Tooltip>
          <TooltipTrigger asChild>
            <button
              type="button"
              className="-m-0.5 inline-flex shrink-0 items-center justify-center rounded-full p-0.5 text-muted-foreground transition-colors hover:text-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2"
              aria-label={hint}
            >
              <Info className="w-3 h-3" strokeWidth={2.25} aria-hidden />
            </button>
          </TooltipTrigger>
          <TooltipContent side="top" className="max-w-sm text-xs leading-relaxed">
            {hint}
          </TooltipContent>
        </Tooltip>
      ) : null}
    </div>
  );
};
